// extracted by mini-css-extract-plugin
export default {"productDescription":"Q--z","featuredDescription":"R--z","description":"S--z","more":"T--z","descriptionSku":"U--z"};